// Tiny markdown renderer — bold, italic, inline code, fences, line breaks.
// Just enough for Coach replies without pulling 50KB of markdown lib.

export function renderMd(text) {
  if (!text) return null
  const out = []
  const lines = text.split('\n')
  let fence = null
  let buf = []

  function flushPara() {
    if (!buf.length) return
    out.push(<p key={out.length} className="whitespace-pre-wrap">{inline(buf.join('\n'))}</p>)
    buf = []
  }

  for (const line of lines) {
    if (fence !== null) {
      if (line.startsWith('```')) {
        out.push(
          <pre key={out.length} className="text-[11px] bg-black/30 border border-card rounded p-2 overflow-x-auto my-2">
            <code>{fence.join('\n')}</code>
          </pre>,
        )
        fence = null
      } else {
        fence.push(line)
      }
      continue
    }
    if (line.startsWith('```')) {
      flushPara()
      fence = []
      continue
    }
    if (/^(\s*)[-*]\s+/.test(line)) {
      flushPara()
      out.push(<li key={out.length} className="ml-5 list-disc">{inline(line.replace(/^(\s*)[-*]\s+/, ''))}</li>)
      continue
    }
    if (/^#{1,6}\s+/.test(line)) {
      flushPara()
      const level = line.match(/^#+/)[0].length
      const Tag = `h${Math.min(level + 2, 6)}`
      out.push(<Tag key={out.length} className="font-display tracking-wider mt-2">{inline(line.replace(/^#+\s+/, ''))}</Tag>)
      continue
    }
    if (line.trim() === '') { flushPara(); continue }
    buf.push(line)
  }
  flushPara()
  return out
}

function inline(text) {
  // Escape HTML, then re-apply tokens. We avoid dangerouslySetInnerHTML.
  const parts = []
  let i = 0, last = 0
  const push = (k, content) => parts.push(<span key={parts.length} className={k}>{content}</span>)
  // Regex: **bold** / *italic* / `code` / [text](url)
  const re = /(\*\*[^*]+\*\*)|(\*[^*]+\*)|(`[^`]+`)|(\[[^\]]+\]\([^)]+\))/g
  let m
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index))
    const tok = m[0]
    if (tok.startsWith('**')) push('font-semibold', tok.slice(2, -2))
    else if (tok.startsWith('`')) push('font-mono text-[var(--accent)] bg-black/20 px-1 rounded', tok.slice(1, -1))
    else if (tok.startsWith('[')) {
      const linkM = /\[([^\]]+)\]\(([^)]+)\)/.exec(tok)
      parts.push(<a key={parts.length} href={linkM[2]} target="_blank" rel="noreferrer" className="text-accent underline">{linkM[1]}</a>)
    } else push('italic', tok.slice(1, -1))
    last = m.index + tok.length
    i++
  }
  if (last < text.length) parts.push(text.slice(last))
  return parts.length ? parts : text
}
